/**
 * Reveal-on-scroll for [data-reveal] elements.
 *
 * Adds `js-reveal` to <html> so the hiding styles apply only when this
 * module actually runs; without JS the content is simply visible. Under
 * prefers-reduced-motion nothing is observed and nothing is hidden.
 */
const prefersReducedMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)'
).matches;

const targets = document.querySelectorAll('[data-reveal]');

if (!prefersReducedMotion && targets.length > 0 && 'IntersectionObserver' in window) {
  document.documentElement.classList.add('js-reveal');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.15 }
  );

  for (const target of targets) {
    observer.observe(target);
  }
}
